export default "__VITE_ASSET__CeAcxUMy__"